import "core-js/modules/es.object.keys.js";
export default {
  data: function data() {
    return {
      url: localStorage.getItem('labInfo') ? JSON.parse(localStorage.getItem('labInfo')).digitalTwinUrl : ''
    };
  },
  mounted: function mounted() {
    if (!this.url) {
      this.$message.info('企业未填写数字孪生地址！');
    }
  },
  methods: {
    backClick: function backClick() {
      this.$router.back();
    }
  }
};